import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../lib/api";

const CustomerAuthContext = createContext(null);

export function CustomerAuthProvider({ children }) {
    const [customer, setCustomer] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("sg_customer_token");
        if (token) {
            api.get("/customer/me", { headers: { Authorization: `Bearer ${token}` } }).then(r => {
                setCustomer(r.data);
            }).catch(() => {
                localStorage.removeItem("sg_customer_token");
            }).finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, []);

    const login = async (email, password) => {
        const r = await api.post("/customer/login", { email, password });
        localStorage.setItem("sg_customer_token", r.data.token);
        setCustomer(r.data);
        return r.data;
    };

    const register = async (data) => {
        const r = await api.post("/customer/register", data);
        localStorage.setItem("sg_customer_token", r.data.token);
        setCustomer(r.data);
        return r.data;
    };

    const guestLookup = async (orderNumber, email) => {
        const r = await api.post("/customer/guest-lookup", { order_number: orderNumber, email });
        localStorage.setItem("sg_customer_token", r.data.token);
        setCustomer(r.data);
        return r.data;
    };

    const logout = () => {
        localStorage.removeItem("sg_customer_token");
        setCustomer(null);
    };

    return (
        <CustomerAuthContext.Provider value={{ customer, loading, login, register, guestLookup, logout }}>
            {children}
        </CustomerAuthContext.Provider>
    );
}

export const useCustomerAuth = () => useContext(CustomerAuthContext);
